import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['scrollContainer', 'focus'];

  scrollContainerTargetConnected(element) {
    element.addEventListener('wheel', (evt) => {
      evt.preventDefault();
      element.scrollLeft += evt.deltaY;
    });
  }

  focusTargetConnected(element) {
    element.scrollIntoView({ inline: 'center', block: 'end' });
  }

  focus(evt) {
    const element = evt.target.parentElement;
    element.scrollIntoView({ inline: 'center', block: 'nearest' });
  }
}
